module.exports = __webpack_public_path__ + "assets/CTA.ca4d6448.png";